<template>
  <div class="results-content-block">
    <pad-unavailable
      v-if="show_unavailable_property && !searching && !appending"
      class="pb-4"
      :hotel="unavailable_property"
      :checkin="requested_dates.checkin"
      :checkout="requested_dates.checkout"
      :alternative_dates="alternative_dates.dates"
      @select="(dates) => $emit('alternative-date-select', dates)"
    />
    <not-found
      v-if="hotels.length === 0 && !searching && !appending && !show_unavailable_property"
      icon="lens-blocked"
      :text="{
        title: '<strong>Oops!</strong><br/>Non abbiamo trovato risultati.',
        message:
          'Sembra che non ci siano hotel che corrispondono alla tua ricerca.',
        suggestion:
          'Prova a togliere uno o più filtri o a cambiare le date per ampliare la ricerca.',
      }"
    >
      <!-- <vb-button
        class="not-found__cta"
        v-if="filters_length > 0"
        :vb_options="{
          text: 'Rimuovi tutti i filtri e riprova',
          variant: 'outline-info',
          size: 'sm',
        }"
        @click="reset_filters"
      /> -->
    </not-found>
    <dynamic-scroller
      ref="results-scroller"
      page-mode
      :items="items"
      :item-size="null"
      :min-item-size="100"
      key-field="property_id"
    >
      <template v-slot="{ item, index, active }">
        <dynamic-scroller-item
          class="pb-4"
          :item="item"
          :data-index="index"
          :active="active"
        >
          <component
            :is="item.component"
            v-if="item.component"
            v-bind="item.props"
          />
          <pad v-else :hotel="item" @toggle-map="toggle_map(item)" />
        </dynamic-scroller-item>
      </template>
    </dynamic-scroller>
  </div>
</template>

<script>
  import NotFound from '@/components/blocks/not-found';
  import MarketingPad from '@/components/blocks/marketing-pad.vue';
  import Pad from '@liveeps/components/blocks/pad.vue';
  import PadUnavailable from '@liveeps/components/blocks/pad-unavailable.vue';
  import { add_extra_components_to_results } from '@/utilities';

  export default {
    name: 'results-content-block',

    components: {
      'not-found': NotFound,
      'marketing-pad': MarketingPad,
      pad: Pad,
      'pad-unavailable': PadUnavailable,
    },

    props: {
      hotels: {
        type: Array,
        default: () => [],
      },
      searching: Boolean,
      appending: Boolean,
      filters_length: {
        type: Number,
        default: 0,
      },
      show_unavailable_property: Boolean,
      unavailable_property: {
        type: Object,
        default: null,
      },
      requested_dates: {
        type: Object,
        default: () => ({}),
      },
      alternative_dates: {
        type: Object,
        default: null,
      },
    },

    data() {
      return {};
    },

    computed: {
      items() {
        return this.add_extra_components_to_results(this.hotels, 'property_id');
      },
    },

    // created() {},

    // mounted() {},

    methods: {
      add_extra_components_to_results,
      reset_filters() {
        this.$emit('reset-filters');
      },

      toggle_map(payload) {
        this.$emit('toggle-map', payload);
      },
    },
  };
</script>

<style lang="scss" scoped></style>
